const DEFAULT_THRESHOLD = 100;

export function getAdjustmentMassiveThreshold(moduleSettings) {
  const raw = moduleSettings?.adjustment_massive_item_threshold;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : DEFAULT_THRESHOLD;
}

export function isMassiveGuideDocument(itemsCount, moduleSettings) {
  const count = Number(itemsCount) || 0;
  return count >= getAdjustmentMassiveThreshold(moduleSettings);
}
